import { render, staticRenderFns } from "./SelectServe.vue?vue&type=template&id=60b93a96&"
import script from "./SelectServe.vue?vue&type=script&lang=js&"
export * from "./SelectServe.vue?vue&type=script&lang=js&"
import style0 from "./SelectServe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports